module.exports = __webpack_public_path__ + "img/result_txt_gq.043023e5.png";